import { Locale } from '@/providers/Locale/types'
import { NextRequest } from 'next/server'

export const locales: Array<string> = ['en', 'es', 'fr', 'de'] satisfies Array<Locale>
export const localeMap: Record<Locale, string> = {
    en: 'English',
    fr: 'Français',
    es: 'Español',
    de: 'Deutsch',
}

export function getLocaleFromRequest(req: NextRequest) {
    const proxiedHost = req.headers.get('x-forwarded-host')

    if (proxiedHost) {
        const subdomain = proxiedHost.split('.')[0]
        if (subdomain && locales.includes(subdomain)) {
            return subdomain as Locale
        }
    }

    return getLocaleFromUrl(req.nextUrl)
}

export function getLocaleFromUrl(url: URL): Locale {
    const assumedLocale = url.pathname.split('/')[1]
    if (assumedLocale && locales.includes(assumedLocale)) {
        return assumedLocale as Locale
    }

    const subdomain = url.hostname.split('.')[0]
    if (subdomain && locales.includes(subdomain)) {
        return subdomain as Locale
    }

    return 'en'
}

export function hasLocaleInUrlPath(url: URL, locale?: Locale) {
    if (locale) {
        return url.pathname.startsWith(`/${locale}/`) || url.pathname === `/${locale}`
    }

    return isAllowedLocale(url.pathname.split('/')[1])
}

export function getHostnameWithLocale(hostname: string, locale: Locale) {
    let parts = hostname.split('.')
    const subdomain = parts[0]
    if (locales.includes(subdomain as Locale)) {
        // Locale is already included in host therefore we must take all parts after the subdomain
        // Assume root is en
        parts = parts.slice(1)
    }

    // Local hash, we keep hash and append locale
    if (subdomain === '#') {
        return `#${locale}`
    }

    return locale === 'en' ? parts.join('.') : [locale, ...parts].join('.')
}

export function isAllowedLocale(locale: unknown): locale is Locale {
    return typeof locale === 'string' && locales.includes(locale)
}
